import React from "react";
import img1 from "../../images/background/img02.jpg";
import img2 from "../../images/background/img1.JPG";
import img3 from "../../images/activities/education/img (11).jpg";
import img4 from "../../images/activities/education/img (86).jpg";
import img5 from "../../images/activities/education/img (21).jpg";
import img6 from "../../images/activities/humanitarian/img (13).jpg";



const WhatWeDo = () => {
  const sections = [
    {
      title: "Action Not Words",
      content: "Action Not Words ensures every cent raised goes directly to children and families in Afghanistan. We provide essential aid—including school supplies, technology, clothing, food, and infrastructure—to support students and their communities. This year, we built a modern library for an elementary school of 1,200 students in Kabul, fully equipped with books, computers, and TVs, and installed solar panels to address the energy crisis sustainably. We also supported families during COVID-19 by providing food, clothing, and face masks in partnership with local businesses.",
      image: img1,
      imageAlt: "Children studying in library",
      imageCaption: "Modern library built for 1,200 students in Kabul",
      delay: 100
    },
    {
      title: "Sedaqat Educational Center",
      content: "Managed by Aiesha Hakimi, the Sedaqat Educational Center serves 140 students in grades one through six in Dasht-e-Barchi. The center offers eight hours of daily instruction in English, Math, Pashto, and foundational skills, supported by four teachers, administrative staff, and a guard. Monthly operating costs range from $550–$600, covering rent, utilities, salaries, and learning materials for students.",
      image: img2,
      imageAlt: "Elementary school classroom",
      imageCaption: "140 students receiving quality education daily",
      delay: 200
    },
    {
      title: "Action Not Word Educational Course",
      content: "Located in the Qasaba area and managed by Walid Hoida, this course offers lessons in religious subjects, sewing, drawing, English, and math. The program provides students with both academic knowledge and practical skills that will serve them throughout their lives. The monthly expenses are approximately $300.",
      image: img3,
      imageAlt: "Students learning practical skills",
      imageCaption: "Practical skill development for lifelong success",
      delay: 300
    },
    {
      title: "One Hour for Afghanistan (OHA)",
      content: "Founded by the family of Mohammad Waris 'Azimi' and active for over seven years, One Hour for Afghanistan (OHA) serves both boys and girls. They recently established a sewing class for women to help them become self-sufficient and economically independent. Managed by Homayoun Ebrahim Khail, the monthly expenses are around $400, ensuring quality education and empowerment opportunities.",
      image: img4,
      imageAlt: "Women learning sewing skills",
      imageCaption: "Empowering women through vocational training",
      delay: 400
    },
    {
      title: "Indoor Soccer Team",
      content: "Managed by Atiq Raheen, this team is for children in grades four to six. They actively participate in regular training sessions and competitive tournaments, with a monthly expense of $200. The program promotes physical fitness, teamwork, discipline, and provides children with a safe space to play and develop.",
      image: img5,
      imageAlt: "Children playing soccer indoors",
      imageCaption: "Promoting teamwork and physical fitness",
      delay: 500
    },
    {
      title: "Additional Support",
      content: "Besides these core activities, the foundation provides assistance to those in need during various occasions such as Eid or in times of natural disasters. We respond to emergencies and community needs as they arise, ensuring no one is left behind in times of crisis.",
      image: img6,
      imageAlt: "Community support and aid distribution",
      imageCaption: "Emergency support during times of crisis",
      delay: 600
    }
  ];

  return (
    <div className="whatWeDo">
      <h1 data-aos="fade-down" data-aos-delay="100">
        Where Your Donation Goes
      </h1>
      {sections.map((section, index) => (
        <section 
          key={index} 
          data-aos="fade-up" 
          data-aos-delay={section.delay}
          className={index % 2 === 0 ? "" : "alternate"}
        >
          <div className="section-image">
            <img 
              src={section.image} 
              alt={section.imageAlt}
              loading="lazy"
            />
            <div className="image-overlay">
              <p>{section.imageCaption}</p>
            </div>
          </div>
          <div className="section-content">
            <h2>{section.title}</h2>
            <p>{section.content}</p>
          </div>
        </section>
      ))}
    </div>
  );
};

export default WhatWeDo;
